import { render, staticRenderFns } from "./creat_by_bl.vue?vue&type=template&id=54775ae3&scoped=true&"
import script from "./creat_by_bl.vue?vue&type=script&lang=js&"
export * from "./creat_by_bl.vue?vue&type=script&lang=js&"
import style0 from "./creat_by_bl.vue?vue&type=style&index=0&id=54775ae3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54775ae3",
  null
  
)

export default component.exports